import n from "styled-components";
import { Base as t, Input as s } from "./atoms-v2777.js";
const d = n.label`
  ${t}
  --radio-size: 18px;
  --radio-cell: 1/1;

  ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.body.compact-productive")) == null ? void 0 : o.toJS();
}}

  align-items: ${({ $isSkeleton: i }) => i ? "center" : "start"};
  color: ${({ $colorTheme: i = "light", $isDisabled: o, theme: a }) => o ? a == null ? void 0 : a.get(`tokens.text.${i}.disabled`) : a == null ? void 0 : a.get(`tokens.text.${i}.primary`)};
  column-gap: 8px;
  cursor: ${({ $isDisabled: i, $isReadonly: o, $isSkeleton: a }) => i || o || a ? "default" : "pointer"};
  display: grid;
  grid-template-areas: 'input label';
  grid-template-columns: ${({ $layout: i }) => i === "default" ? "min-content auto" : "auto min-content"};
  min-width: ${({ $isSkeleton: i }) => i ? "100px" : "auto"};
`, u = n.input`
  ${s}

  background-color: ${({ $colorTheme: i = "light", theme: o }) => o == null ? void 0 : o.get(`tokens.surface.${i}.background`)};
  border-radius: 50%;
  box-shadow: inset 0 0 0 1.5px
    ${({ $colorTheme: i = "light", disabled: o, readOnly: a, theme: r }) => o || a ? r == null ? void 0 : r.get(`ui.icon.${i}.disabled`) : r == null ? void 0 : r.get(`ui.icon.${i}.default`)};
  color: currentcolor;
  display: grid;
  font: inherit;
  grid-area: ${({ $layout: i }) => i === "default" ? "input" : "label"};
  height: var(--radio-size);
  place-content: center;
  position: relative;
  width: var(--radio-size);

  &::before {
    border-radius: 50%;
    box-shadow: inset var(--radio-size) var(--radio-size)
      ${({ $colorTheme: i = "light", disabled: o, readOnly: a, theme: r }) => o || a ? r == null ? void 0 : r.get(`ui.icon.${i}.disabled`) : r == null ? void 0 : r.get(`ui.icon.${i}.default`)};
    content: '';
    height: calc(var(--radio-size) - 10px);
    transform: scale(0);
    transition-duration: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.motion").toString("duration.fast")};
    transition-property: transform;
    transition-timing-function: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.motion").toString("easing.standard")};
    width: calc(var(--radio-size) - 10px);
  }

  &:checked::before {
    transform: scale(1);
  }

  &::after {
    border-radius: 50%;
    content: '';
    inset: 0;
    outline: 2px solid currentcolor;
    outline-offset: 1.5px;
    position: absolute;
    visibility: hidden;
  }

  &:focus-visible::after {
    visibility: visible;
  }
`, g = n.span`
  background-color: ${({ $colorTheme: i = "light", theme: o }) => o == null ? void 0 : o.get(`ui.radio.${i}.bkgHover`)};
  border-radius: 50%;
  box-shadow: 0 0 0 8px ${({ theme: i }) => i == null ? void 0 : i.get("tokens.colors.grey.15")};
  grid-area: ${({ $layout: i }) => i === "default" ? "input" : "label"};
  height: var(--radio-size);
  visibility: hidden;
  width: var(--radio-size);
  z-index: -1;

  ${d}:hover & {
    visibility: visible;
  }
`, p = n.span`
  grid-area: ${({ $layout: i }) => i === "default" ? "label" : "input"};
`;
export {
  g as Hover,
  d as Label,
  p as LabelText,
  u as Radio
};
